// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-viewer {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.pdf-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.pdf-nav-btn {
  padding: 0.5rem 1rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.pdf-nav-btn:hover:not(:disabled) {
  background-color: #2980b9;
}

.pdf-nav-btn:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}

.pdf-page-info {
  font-weight: 500;
  color: #2c3e50;
}

.pdf-document {
  flex: 1 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  padding: 2rem;
  background-color: #525659;
}

.pdf-document canvas {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  max-width: 100%;
}

.pdf-viewer-loading,
.pdf-viewer-error {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  color: #7f8c8d;
}

.pdf-viewer-error {
  color: #e74c3c;
}

.pdf-retry-btn {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.pdf-retry-btn:hover {
  background-color: #2980b9;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .pdf-controls {
    flex-wrap: wrap;
    padding: 0.75rem;
    gap: 0.6rem;
  }

  .pdf-nav-btn {
    padding: 0.4rem 0.85rem;
    font-size: 0.9rem;
  }

  .pdf-page-info {
    font-size: 0.9rem;
  }

  .pdf-document {
    padding: 1rem;
  }

  .pdf-viewer-loading,
  .pdf-viewer-error {
    height: 200px;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .pdf-controls {
    padding: 0.5rem;
    gap: 0.5rem;
  }

  .pdf-nav-btn {
    padding: 0.35rem 0.75rem;
    font-size: 0.85rem;
  }

  .pdf-page-info {
    font-size: 0.85rem;
  }

  .pdf-document {
    padding: 0.5rem;
  }

  .pdf-viewer-loading,
  .pdf-viewer-error {
    height: 150px;
    font-size: 0.85rem;
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PdfViewer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,kBAAkB;IAClB,aAAa;EACf;AACF","sourcesContent":[".pdf-viewer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.pdf-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.pdf-nav-btn {\n  padding: 0.5rem 1rem;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.pdf-nav-btn:hover:not(:disabled) {\n  background-color: #2980b9;\n}\n\n.pdf-nav-btn:disabled {\n  background-color: #95a5a6;\n  cursor: not-allowed;\n}\n\n.pdf-page-info {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.pdf-document {\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  justify-content: center;\n  padding: 2rem;\n  background-color: #525659;\n}\n\n.pdf-document canvas {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  max-width: 100%;\n}\n\n.pdf-viewer-loading,\n.pdf-viewer-error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  color: #7f8c8d;\n}\n\n.pdf-viewer-error {\n  color: #e74c3c;\n}\n\n.pdf-retry-btn {\n  margin-top: 1rem;\n  padding: 0.5rem 1rem;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.pdf-retry-btn:hover {\n  background-color: #2980b9;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .pdf-controls {\n    flex-wrap: wrap;\n    padding: 0.75rem;\n    gap: 0.6rem;\n  }\n\n  .pdf-nav-btn {\n    padding: 0.4rem 0.85rem;\n    font-size: 0.9rem;\n  }\n\n  .pdf-page-info {\n    font-size: 0.9rem;\n  }\n\n  .pdf-document {\n    padding: 1rem;\n  }\n\n  .pdf-viewer-loading,\n  .pdf-viewer-error {\n    height: 200px;\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .pdf-controls {\n    padding: 0.5rem;\n    gap: 0.5rem;\n  }\n\n  .pdf-nav-btn {\n    padding: 0.35rem 0.75rem;\n    font-size: 0.85rem;\n  }\n\n  .pdf-page-info {\n    font-size: 0.85rem;\n  }\n\n  .pdf-document {\n    padding: 0.5rem;\n  }\n\n  .pdf-viewer-loading,\n  .pdf-viewer-error {\n    height: 150px;\n    font-size: 0.85rem;\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
